import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import SearchItems from '../software_pages/serach_software/SearchItems';
import Link from 'react-router-dom/Link';
const algoliasearch = require('algoliasearch');

/**
 * Handles the searching of the component
 */
class SearchSoftwarePage extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.searchChange = this.searchChange.bind(this);

    const client = algoliasearch(
      'E2SNSK2V24',
      '82fd6ee56c067f64d5fd8f63ab35b999'
    );
    this.index = client.initIndex('product_pages');

    this.state = {
      prodType: 'Software',
      searchText: '',
      products: [],
      updated: false,
    };
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value, products: [] });
  }

  searchChange(event) {
    event.preventDefault();
    let searchParam = event.target.value;

    if (searchParam === '') {

    }

    this.index
      .search(searchParam, {
        filters: 'prodType:' + this.state.prodType,
      })
      .then(hits => {
        this.setState({ products: hits.hits, updated: !this.state.updated });
      });
  }

  render() {
    return (
      <div className="container">
        {
          this.state.loggedIn ?
          < Link to = "/create_product"
            style = {
              {
                margin: '0px 0px 15px 5px'
              }
            } >
            Page doesn't exist yet? Add one now! 
          </Link>
          :
          < Link to = "/login"
            style = {
              {
                margin: '0px 0px 15px 5px'
              }
            } >
            Login to start creating pages now!  
            </Link>
        }
        
        <table style={tableStyle}>
          <tbody>
            <tr>
              <th style={colStyle1}>
                <Form.Control
                  as="select"
                  name="prodType"
                  onChange={this.handleChange}
                >
                  <option>Software</option>
                  <option>Game</option>
                  <option>Website</option>
                  <option>App</option>
                  <option>Others</option>
                  
                </Form.Control>
              </th>
              <th style={colStyle2}>
                <input
                  type="text"
                  required
                  name="searchText"
                  onChange={this.searchChange}
                  className="form-control"
                  placeholder="Ex: 'Coming Book Viewer', '3D space shooter arcade', 'Library asset manager', etc."
                />
              </th>
            </tr>
          </tbody>
        </table>
        <SearchItems products={this.state.products} mySearchItems={false} />
        <br />
      </div>
    );
  }
}

const buttonLinkStyle = {
  background: 'none!important',
  'background-color': 'rgba(0,0,0,0)',
  border: 'none',
  padding: '0!important',
  'font-family': 'arial, sans-serif',
  color: '#069',
  cursor: 'pointer',
  margin: '10px 0px 5px 3px',
};

const tableStyle = {
  width: '100%',
  margin: '5px 0px 0px 0px',
};

const colStyle1 = {
  width: '150px',
};

const colStyle2 = {
  padding: '5px',
};

export default SearchSoftwarePage;
